// Ambiente de un agente (script 49): para saber qué se muestra, qué se prueba y qué atiende gente real.
export const ENVIRONMENTS = [
  { key: 'demo', label: 'Demo', tone: 'neutral', hint: 'Para mostrarlo a un prospecto. No atiende a clientes reales.' },
  { key: 'test', label: 'Pruebas', tone: 'caution', hint: 'En construcción o revisión. Se prueba con el equipo.' },
  { key: 'production', label: 'Producción', tone: 'live', hint: 'Atiende a clientes reales. Se cuida: no se archiva, no se borra y los cambios se piden con cuidado.' },
];
export const envMeta = (key) => ENVIRONMENTS.find((e) => e.key === key) || null;
/** El ambiente del agente, o null si la base de datos aún no tiene el script 49 (entonces no se muestra nada). */
export const envOf = (agent) => (agent && envMeta(agent.environment) ? agent.environment : null);
export const isProduction = (agent) => envOf(agent) === 'production';

/** Lo que falta para pasar un agente a producción, en lenguaje claro (lista vacía = listo). */
export function productionBlockers({ agent, credential, connections = [], project }) {
  const out = [];
  if (agent.status !== 'published') out.push('Publícalo primero: un agente en borrador no puede estar en producción.');
  if (credential?.status !== 'active') out.push('Necesita una clave de OpenAI activa.');
  if (!connections.some((c) => ['connected', 'degraded'].includes(c.status))) out.push('Conecta al menos un canal.');
  if (project && project.engine !== 'runtime') out.push('Enciende el motor del proyecto.');
  return out;
}
